import { Component, Injector, OnInit } from '@angular/core';
import { Departamento } from 'src/app/model/geral/departamento';
import { DepartamentoService } from 'src/app/services/geral/departamento.service';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { GeralFormModule } from './geralform.module';

@Component({
  selector: 'app-form-departamento',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormDepartamentoComponent extends FormGenerico<Departamento> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: DepartamentoService) 
  {
    super(injectorObj, api);
    this.obj = new Departamento();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
